import { SupplierBase } from '@retail/suppliers/types';
import { CalculusArea } from './CalculusAreas';
import { HierarchyLevels } from '@retail/products/types';
import { SupplierItemBinding } from './Conditions';
import { PurchaseConditionNew, RoundingRuleCondition } from './ConditionTypes';
import { PriceSourceCondition } from './ConditionTypes/PriceSourceCondition';
import { ConditionsNewDTO } from '../dtos/ConditionsNewDTO';
import { MarkupConditionNew } from './ConditionTypes/MarkupConditionNew';
import { bindingFromHierarchyLevel, ConditionBinding } from './CreateConditions';
import { FreightConditionNew } from './ConditionTypes/FreightConditionNew';
import { PriceRoundingBrand } from '@retail/rounding/types';
import { CustomerMarkupConditionNew } from './ConditionTypes/CustomerMarkupConditionNew';

export interface ConditionTypes {
  type: CalculusArea;
  id: number;
}
export interface ConditionsNewProps {
  assortmentId: number;
  assortmentName: string;
  inDraft: boolean;
  types: ConditionTypes[];
  type: CalculusArea;
  id: number;
  supplier?: SupplierBase;
  bindingType: HierarchyLevels;
  bindingTargetName: string;
  bindingTargetId: string;
  bindingTargetItem?: SupplierItemBinding;
  purchaseCondition?: PurchaseConditionNew;
  freightCondition?: FreightConditionNew;
  markupCondition?: MarkupConditionNew;
  customerMarkupCondition?: CustomerMarkupConditionNew;
  roundingCondition?: RoundingRuleCondition;
  priceSourceCondition?: PriceSourceCondition;
}

export class ConditionsNew {
  assortmentId: number;
  assortmentName: string;
  inDraft: boolean;
  types: ConditionTypes[];
  type: CalculusArea;
  id: number;
  supplier?: SupplierBase;
  bindingType: HierarchyLevels;
  bindingTargetName: string;
  bindingTargetId: string;
  bindingTargetItem?: SupplierItemBinding;
  purchaseCondition?: PurchaseConditionNew;
  freightCondition?: FreightConditionNew;
  markupCondition?: MarkupConditionNew;
  customerMarkupCondition?: CustomerMarkupConditionNew;
  roundingCondition?: RoundingRuleCondition;
  priceSourceCondition?: PriceSourceCondition;

  constructor({
    assortmentId,
    assortmentName,
    inDraft,
    types,
    type,
    id,
    supplier,
    bindingType,
    bindingTargetName,
    bindingTargetId,
    bindingTargetItem,
    purchaseCondition,
    freightCondition,
    markupCondition,
    customerMarkupCondition,
    roundingCondition,
    priceSourceCondition,
  }: ConditionsNewProps) {
    this.assortmentId = assortmentId;
    this.assortmentName = assortmentName;
    this.inDraft = inDraft;
    this.types = types;
    this.type = type;
    this.id = id;
    this.supplier = supplier;
    this.bindingType = bindingType;
    this.bindingTargetName = bindingTargetName;
    this.bindingTargetId = bindingTargetId;
    this.bindingTargetItem = bindingTargetItem;
    this.purchaseCondition = purchaseCondition;
    this.freightCondition = freightCondition;
    this.markupCondition = markupCondition;
    this.customerMarkupCondition = customerMarkupCondition;
    this.roundingCondition = roundingCondition;
    this.priceSourceCondition = priceSourceCondition;
  }

  getBindingLevel = (): ConditionBinding =>
    bindingFromHierarchyLevel(this.bindingType, this.bindingTargetId, this.supplier?.supplierNumber);

  static fromDto = (dto: ConditionsNewDTO, selectedBrand: PriceRoundingBrand): ConditionsNew =>
    new ConditionsNew({
      assortmentId: dto.assortmentId,
      assortmentName: dto.assortmentName,
      inDraft: dto.inDraft,
      types: dto.types,
      //In approval and calculus there will always be only one type
      type: dto.types[0]?.type,
      id: dto.types[0]?.id,
      supplier: dto.supplier ? SupplierBase.fromDto(dto.supplier) : undefined,
      bindingType: dto.bindingType,
      bindingTargetName: dto.bindingTargetName,
      bindingTargetId: dto.bindingTargetId,
      bindingTargetItem: dto.bindingTargetItem,
      purchaseCondition: dto.purchaseCondition
        ? PurchaseConditionNew.fromDto(dto.purchaseCondition)
        : undefined,
      freightCondition: dto.freightCondition
        ? FreightConditionNew.fromDto(dto.freightCondition)
        : undefined,
      markupCondition: dto.markupCondition
        ? MarkupConditionNew.fromDto(dto.markupCondition)
        : undefined,
      customerMarkupCondition: dto.customerMarkupCondition
        ? CustomerMarkupConditionNew.fromDto(dto.customerMarkupCondition)
        : undefined,
      roundingCondition: dto.roundingCondition
        ? RoundingRuleCondition.fromDto(dto.roundingCondition, selectedBrand)
        : undefined,
      priceSourceCondition: dto.priceSourceCondition
        ? PriceSourceCondition.fromDto(dto.priceSourceCondition)
        : undefined,
    });
}
